import React, { useEffect } from 'react';
import styled from 'styled-components';
import { WorkSortOrder } from '../../shared/enum/EnumRepository';
import { useWorkPropertyVisible } from '../../shared/hooks/useApi/useWorkPropertyVisible';
import { useWorkIndexing } from '../../shared/hooks/useWorkIndexing';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';
import BlockWithSortVisible from './BlockWithSortVisible';
import BlockWithVisible from './BlockWithVisible';
import WorkOverviewEditActions from './WorkOverviewEditActions';

const AttributedColumnInfo: React.FC = () => {
  const { workPropertyVisible, getWorkPropertyVisible } = useWorkPropertyVisible();
  const isOverviewOpen = useWorkViewStore((s) => s.isOverviewOpen);
  const { isIndexingMode } = useWorkIndexing();

  useEffect(() => {
    void getWorkPropertyVisible();
  }, []);

  if (!workPropertyVisible) return null;

  const showOverview = isOverviewOpen || isIndexingMode;

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <ImageBlock />
        <BlockWithSortVisible
          width="1.2"
          isColumn
          align="left"
          field={WorkSortOrder.ARTIST_NAME}
          value="Name"
        />
        <BlockWithSortVisible width="2.5" isColumn field={WorkSortOrder.TITLE} value="Title" />
        <BlockWithVisible width="1.5" isColumn value="Size(unit)" />
        <BlockWithVisible width="2" isColumn value="Material" />
        <BlockWithSortVisible width="0.8" isColumn field={WorkSortOrder.YEAR} value="Year" />
        <BlockWithVisible width="1.2" isColumn field="workType" value="Type" />
        <BlockWithVisible width="1" isColumn field="price" value="Price" />
        <BlockWithVisible width="1" isColumn field="collection" value="Collection" />
        {showOverview && <SpaceBlock />}
      </InfoContainer>
      {showOverview && (
        <OverviewBlock>
          {isIndexingMode ? 'Indexing' : 'Overview'}
          <WorkOverviewEditActions />
        </OverviewBlock>
      )}
    </ColumnInfoComp>
  );
};

export default AttributedColumnInfo;

const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_03_2};
`;

const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;

const ImageBlock = styled.div`
  flex: 0.5;
  min-width: 40px;
  max-width: 50px;
  border-right: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

const SpaceBlock = styled.div`
  flex: 0.15;
`;

const OverviewBlock = styled.div`
  width: 29vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 2px;
`;
